import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import Menu from '../../../Menu/Menu'
import PatientHeader from './PatientHeader/PatientHeader'
import PathologiesGridContainer from './PathologiesGrid/PathologiesGridContainer'
import Patient from '../../../../models/Patient/Patient'
import FloatingButton from '../../../FloatingButton/FloatingButton'
import ImmunizationInsertionContainer from './ImmunizationInsertion/ImmunizationInsertionContainer'
import ReceiptContainer from './Receipt/ReceiptContainer'
import withPolyglot from '../../../common/withPolyglot'
import { INSERTION_TYPE } from '../../../../resources/utilities'

function getNavigation (currentUrl) {
  return [
    {
      path: `${currentUrl}`,
      exact: true,
      name: 'mainView'
    }, {
      path: `${currentUrl}/planEdit`,
      exact: false,
      name: 'planEdit'
    },
    {
      path: `${currentUrl}/receipt`,
      exact: false,
      name: 'receipt'
    }
  ]
}

const PatientViewer = ({selectEmptyInsertion, selectPreviousInsertion, match, patient, translate}) => {
  return <Fragment>
    <PatientHeader
      patientId={patient.id}
      name={patient.name}
      birthDate={patient.birthDate}
      formattedBirthDate={patient.getFormattedBirthDate('pt-PT')}
      img={patient.photo} />
    <Menu navigation={getNavigation(match.url)} />
    <FloatingButton
      secondaryOptions={[{
        onClick: () => selectPreviousInsertion(INSERTION_TYPE.PREVIOUS),
        icon: 'fas fa-history',
        toolTip: translate('addPreviousImmunization')
      }, {
        onClick: () => selectEmptyInsertion(INSERTION_TYPE.IMMUNOGLOBULIN),
        icon: 'fas fa-vial',
        toolTip: translate('addImmunoglobulin')
      }, {
        onClick: () => selectEmptyInsertion(INSERTION_TYPE.VACCINE),
        icon: 'fas fa-syringe',
        toolTip: translate('addVaccine')
      }]} />
    <ImmunizationInsertionContainer />
    <Switch>
      <Route
        exact
        path={match.path}
        render={() => <PathologiesGridContainer />} />
      <Route
        path={`${match.path}/planEdit`}
        render={() => <PathologiesGridContainer editMode />} />
      <Route
        path={`${match.path}/receipt`}
        render={props => <ReceiptContainer {...props} />} />
    </Switch>
  </Fragment>
}

PatientViewer.propTypes = {
  match: PropTypes.object.isRequired,
  patient: PropTypes.instanceOf(Patient).isRequired,
  history: PropTypes.object,
  selectEmptyInsertion: PropTypes.func.isRequired,
  selectPreviousInsertion: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired
}

export default withPolyglot(PatientViewer, 'patientViewer')
